module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-card-body"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.commissionLists,
      "paginator": true,
      "rows": 8
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n        " + _vm._s(slotProps.index + 1) + "\n       ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Commision Name",
      "field": "commissionName",
      "filterField": "comissionName",
      "filterMatchMode": "contains"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Commission Type",
      "field": "type"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Quantity From",
      "field": "fromQty"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Quantity To",
      "field": "toQty"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "field": ""
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-success p-button-sm",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editCommision(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteCommision
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65d291d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/CommisionSetup/commisionList.vue
// module id = 2276
// module chunks = 0